/************************************************************
 Dental Medicine Namespace
 ************************************************************/

 window.DentalMedicineNS = {

    getOdontogramsViews: function(params, callback){
        Hades.showLoading();

        $.getJSON('dental_consult/get_odontogram_views', params)
            .done(function (data, status, xhr) {
                Hades.hideLoading();

                if(callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });


    },

    getOdontogramsMoreOptions: function(params, callback){
        Hades.showLoading();

        $.getJSON('dental_consult/get_odontogram_add_options', params)
            .done(function (data, status, xhr) {
                Hades.hideLoading();

                if(callback){
                    callback(data);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });


    }

};